import { Store } from 'vuex'
import createPersistedState from 'vuex-persistedstate'

import { actions } from './actions'
import { getters } from './getters'
import { mutations } from './mutations'
import { state } from './state'
import { StateInterface } from './state.interface'

export const PERSISTENCE_KEY = 'divera247'

export const store = new Store<StateInterface>({
  state,
  plugins: [
    createPersistedState({
      key: PERSISTENCE_KEY,
      paths: [
        'alarm', 'cluster', 'dashboard', 'dm', 'events', 'localmonitor',
        'message', 'message_channel', 'monitor', 'news',
        'status', 'statusplan', 'ucr', 'ucr_active', 'ucr_default',
        'user', 'messenger', 'vehicle_status_history', 'app',
        'encryption_keys', 'jwt', 'pull_service'
      ]
    })
  ],
  actions,
  getters,
  mutations
})
